export const version = '1.2.14';
//# sourceMappingURL=version.js.map